import { useState } from 'react';
import {
  CaratKey,
  GOLD_DATA,
  GoldCalculatorProps,
  UseGoldCalculatorReturn,
} from '../../common/types';

export const CARAT_OPTIONS: { label: string; value: CaratKey }[] = [
  { label: '24K', value: '24k' },
  { label: '22K', value: '22k' },
  { label: '18K', value: '18k' },
  { label: '14K', value: '14k' },
  { label: '12K', value: '12k' },
  { label: '9K', value: '9k' },
];

export const getRate = (data: GOLD_DATA, carat: CaratKey): number => {
  const caratMap: Record<CaratKey, number> = {
    '24k': data.carat24.ratePerGram,
    '22k': data.carat22.ratePerGram,
    '18k': data.carat18.ratePerGram,
    '14k': data.carat14.ratePerGram,
    '12k': data.carat12.ratePerGram,
    '9k': data.carat9.ratePerGram,
  };
  return caratMap[carat];
};

export const useGoldCalculator = ({
  data,
}: GoldCalculatorProps): UseGoldCalculatorReturn => {
  const [selectedCarat, setSelectedCarat] = useState<CaratKey>('24k');
  const [isWeightToAmount, setIsWeightToAmount] = useState(true);
  const [inputValue, setInputValue] = useState('');

  const ratePerGram = getRate(data, selectedCarat);

  const calculateResult = (): string => {
    const value = parseFloat(inputValue);
    if (!inputValue || isNaN(value) || value <= 0) return '';

    if (isWeightToAmount) {
      return `₹${Math.round(value * ratePerGram).toLocaleString('en-IN')}`;
    }
    return `${(value / ratePerGram).toFixed(2)} g`;
  };

  const handleSwap = () => {
    setIsWeightToAmount((prev) => !prev);
    setInputValue('');
  };

  return {
    selectedCarat,
    setSelectedCarat,
    isWeightToAmount,
    inputValue,
    setInputValue,
    ratePerGram,
    calculateResult,
    handleSwap,
  };
};
